import React from 'react';
import { Handle, Position } from 'reactflow';
import { Upload } from 'lucide-react';

const UploadNode = ({ data, isConnectable }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-orange-200 node-upload">
      <div className="flex items-center">
        <Upload className="w-4 h-4 text-orange-600 mr-2" />
        <div className="ml-2">
          <div className="text-lg font-bold text-orange-800">Upload Image</div>
          <div className="text-sm text-gray-600">
            Analyze textbook images
          </div>
          <div className="text-xs text-orange-600">
            Max: {data.config?.maxSize || '10MB'} • {data.config?.fileType || 'image'}
          </div>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-orange-500 border-2 border-white"
      />
    </div>
  );
};

export default UploadNode;